<template>
  <div class="flex flex-col justify-center">
    <slot name="title"></slot>
    <slot name="description"></slot>
  </div>
</template>
<script>
export default {
  name: 'Story',
};
</script>